import Growx from "../image/growx.png";
import Marketing from "../image/smartcard.jpeg";
import Nestiva from "../image/nestiva.jpeg";

const projects = [
  {
    title: "GrowX Digital Solutions",
    img: Growx,
    link: "https://growx.samrattechitsolutions.com/",
    description:
      "A modern digital solutions platform helping businesses grow through professional website development, digital marketing, branding, AI automation, and lead generation strategies."
  },
  {
    title: "Marketing Website",
    img: Marketing,
    link: "https://smartcard-site.netlify.app/",
    description:
      "A responsive eCommerce website featuring product browsing, shopping cart, wishlist, secure checkout, and an intuitive user experience.",
  },
  {
    title: "Medical Website",
    img: Nestiva,
    link: "https://stellar-pudding-bfbd5b.netlify.app/",
    description:
      "A premium healthcare website with doctor information, medical services, online appointment booking, and an AI-powered chatbot.",
  },
];

export default projects;